import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Lock, ShieldCheck } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { ImzLogo, BsnlLogo } from "@/components/Brand";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => { if (user) navigate("/admin", { replace: true }); }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) navigate("/admin", { replace: true });
    else setError(res.error);
  };

  return (
    <div className="flex min-h-screen items-center justify-center kiosk-radial px-5">
      <div className="w-full max-w-md">
        <div className="mb-8 flex items-center justify-center gap-4">
          <BsnlLogo />
          <span className="h-6 w-px bg-cyan-400/25" />
          <ImzLogo />
        </div>
        <form onSubmit={submit} className="rounded-3xl glass glow-border p-8" data-testid="admin-login-form">
          <div className="mb-6 flex items-center gap-3">
            <div className="flex h-11 w-11 items-center justify-center rounded-xl cyan-grad text-[#041021]"><Lock className="h-5 w-5" /></div>
            <div>
              <h1 className="font-head text-2xl font-bold text-white">Admin Portal</h1>
              <p className="text-xs text-slate-400">Secure content management</p>
            </div>
          </div>
          <div className="space-y-4">
            <div className="space-y-1.5">
              <Label className="text-slate-300">Email</Label>
              <Input data-testid="admin-login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                required className="bg-[#0b1730] border-slate-700 text-white" placeholder="you@company.com" />
            </div>
            <div className="space-y-1.5">
              <Label className="text-slate-300">Password</Label>
              <Input data-testid="admin-login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)}
                required className="bg-[#0b1730] border-slate-700 text-white" placeholder="••••••••" />
            </div>
            {error && <p className="text-sm text-rose-400" data-testid="admin-login-error">{error}</p>}
            <Button data-testid="admin-login-submit" type="submit" disabled={loading}
              className="w-full cyan-grad text-[#041021] font-bold hover:opacity-90 min-h-[48px]">
              {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : "Sign In"}
            </Button>
          </div>
          <div className="mt-5 flex items-center justify-center gap-2 text-xs text-slate-500">
            <ShieldCheck className="h-4 w-4 text-cyan-400/70" /> Protected by role-based access control
          </div>
        </form>
      </div>
    </div>
  );
}
